import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=aba4403a&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aba4403a')) {
      api.createRecord('aba4403a', component.options)
    } else {
      api.reload('aba4403a', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=aba4403a&", function () {
      api.rerender('aba4403a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-484pp4dbPaoN5/JS/comp/FavElement.vue"
export default component.exports